import { Link } from "react-router-dom";
import { Waves } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function BrandMark({ dark, testid = "logo-link" }) {
  const { site } = useSite();
  const name = site?.site_name || "Just Laundry";
  return (
    <Link to="/" className="group flex items-center gap-2.5" data-testid={testid}>
      {site?.logo_url ? (
        <img src={site.logo_url} alt={name} className="h-9 w-auto max-w-[150px] object-contain" />
      ) : (
        <>
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-brand text-white shadow-lg shadow-brand/30 transition-transform duration-300 group-hover:-rotate-6">
            <Waves className="h-5 w-5" strokeWidth={2} />
          </span>
          <span className={`whitespace-nowrap font-heading text-lg font-extrabold tracking-tight sm:text-xl ${dark ? "text-white" : "text-slate-900"}`}>{name}</span>
        </>
      )}
    </Link>
  );
}
